import { createSlice } from "@reduxjs/toolkit"

const Slice = createSlice({
  name: "guestFeedback",
  initialState: {
    initialized: false,
    rating: 0,
    passenger: "",
    toursPerPort: {},
    tours: {},
  },
  reducers: {
    initialize: (state, { payload }) => ({
      ...state,
      ...payload,
      initialized: true,
    }),
    setRating: (state, { payload }) => ({
      ...state,
      rating: payload,
    }),
  },
})

export const { initialize } = Slice.actions

export default Slice
